import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useInView } from '../../../hooks/useInView';

const stats = [
  { icon: 'ri-award-line', value: '8', label: 'Años' },
  { icon: 'ri-user-heart-line', value: '5K+', label: 'Clientes' },
  { icon: 'ri-car-line', value: '20+', label: 'Marcas' },
  { icon: 'ri-shield-check-line', value: '100%', label: 'Garantía' },
];

const features = [
  'Diagnóstico electrónico avanzado',
  'Piezas originales con garantía',
  'Plazos cumplidos al 100%',
  'Presupuesto sin compromiso',
];

const StatsAboutSection = () => {
  const [sectionRef, inView] = useInView(0.1);
  const [imgRef, imgInView] = useInView(0.2);

  return (
    <section className="bg-zinc-950 py-20 px-6 overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto">

        {/* Stats bar */}
        <div className={`grid grid-cols-2 sm:grid-cols-4 mb-16 transition-all duration-700 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`group flex items-center gap-4 px-6 py-6 border border-zinc-800/80 hover:bg-yellow-400/4 transition-colors cursor-default
                ${i > 0 ? 'border-l-0' : ''}
                ${i < 2 ? 'border-b sm:border-b' : ''}
                ${i >= 2 ? 'sm:border-t-0 border-t-0' : ''}
              `}
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-yellow-400/10 border border-yellow-400/15 text-yellow-400 flex-shrink-0">
                <i className={`${stat.icon} text-sm`} />
              </div>
              <div>
                <p className="font-display text-3xl text-yellow-400 leading-none tracking-wide">{stat.value}</p>
                <p className="text-xs text-zinc-500 mt-0.5 uppercase tracking-wider font-medium">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* About */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div
            ref={imgRef}
            className={`relative transition-all duration-800 ${
              imgInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="aspect-[4/3] overflow-hidden border border-zinc-800 bg-zinc-900">
              <img
                alt="Mecánico profesional Taller Kevin Alberto"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                loading="lazy"
                decoding="async"
                src="https://public.readdy.ai/ai/img_res/8ec4e3d3f1ed5803996d03eb8b1c7535.jpg"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-yellow-400 text-black px-5 py-3 hidden lg:flex flex-col items-center border-2 border-black">
              <span className="font-display text-3xl leading-none tracking-wide">8</span>
              <span className="text-[10px] uppercase tracking-widest font-bold">Años</span>
            </div>
            {/* Accent corner */}
            <div className="absolute -top-3 -left-3 w-12 h-12 border-t-2 border-l-2 border-yellow-400/40 hidden lg:block" />
          </div>

          <div
            className={`space-y-6 transition-all duration-800 delay-200 ${
              inView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <div>
              <div className="inline-flex items-center gap-2 mb-4">
                <span className="w-5 h-px bg-yellow-400" />
                <span className="text-yellow-400 text-[10px] font-bold uppercase tracking-[0.3em]">Sobre nosotros</span>
              </div>
              <h2 className="font-display text-4xl md:text-5xl uppercase leading-none text-white tracking-wide">
                Experiencia,{' '}
                <span className="text-yellow-400">Precisión</span>{' '}
                y Confianza
              </h2>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed font-light">
              Durante más de 8 años, en <strong className="text-white font-semibold">Taller Kevin Alberto</strong> hemos
              perfeccionado cada proceso de reparación en Ronda. Tecnología avanzada y especialistas
              cualificados para cualquier marca o modelo.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {features.map((f, i) => (
                <div
                  key={f}
                  className={`flex items-center gap-3 transition-all duration-500 ${
                    inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
                  }`}
                  style={{ transitionDelay: `${0.3 + i * 0.08}s` }}
                >
                  <div className="w-5 h-5 flex items-center justify-center bg-yellow-400/10 border border-yellow-400/25 flex-shrink-0">
                    <i className="ri-check-line text-yellow-400 text-xs" />
                  </div>
                  <span className="text-zinc-300 text-xs font-medium">{f}</span>
                </div>
              ))}
            </div>
            <Link
              to="/nosotros"
              className="group inline-flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-zinc-300 hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap border border-zinc-800 hover:border-yellow-400/30 px-5 py-3 bg-zinc-900/50 hover:bg-yellow-400/5"
            >
              <i className="ri-team-line text-yellow-400" />
              Conoce nuestro equipo
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsAboutSection;
